import { gql } from '@apollo/client'

const companyBranchFields = `
id
name {
  en
  fr
}
logo {
  en
  fr
}
city
region
country
ratings {
  id
  movingWaldo {
    rating
    nbRatings
    professionalism
    punctuality
    communication
  }
  google {
    rating
    nbRatings
  }
}
arrivalWindows
`

const chargeFields = `
pricingCategory
description
overrideDescription
item
quantity
unit
unitPrice {
  price
  currency
}
subtotal {
  price
  currency
}
taxable
`

const jobFields = `
jobId
jobResolvedBranch {
  pricing {
    minLabourTime
  }
  nbMen
  nbTrucks {
    key
    value
  }
  totalDuration
  totalDistance
}
charges {
  ${chargeFields}
}
subtotal {
  price
  currency
}
date
dateRange {
  pickupWindowEndDate
  deliveryWindowStartDate
  deliveryWindowEndDate
}
forAlternativeDate
alternativeDates {
  date
  subtotal {
    price
    currency
  }
  dateAvailable
  timeAvailable
  availableAm
  availablePm
}
constraints
`

export const quoteFields = `
id
createdAt
companyBranch {
  ${companyBranchFields}
}
customized
subtotal {
  price
  currency
}
jobs {
  ${jobFields}
}
`

export const preliminaryQuoteFields = `
totalQuotes
preliminaryQuotes {
  id
  companyLogo
  companyLetter
  price {
    price
    currency
  }
  nbMen
  nbTrucks
}
resolvedOriginAddress {
  city
  region
  country
  postalCode
}
resolvedDestinationAddress {
  city
  region
  country
  postalCode
}
`

export const getPreliminaryQuotes = gql`
query GetPreliminaryQuotes($preliminaryQuotesRequest: PublicQuotesRequestDto!, $promoCode: String) {
  getPreliminaryQuotes(preliminaryQuotesRequest: $preliminaryQuotesRequest, promoCode: $promoCode) {
    ${preliminaryQuoteFields}
  }
}
`

const addressFields = `
placeId
placeTextLine1
placeTextLine2
country
street
apartment
city
region
postalCode
`

export const findAddresses = gql`
query FindAddresses($payload: FindAddressesDto!) {
  findAddresses(payload: $payload) {
    origin {
      ${addressFields}
    }
    destination {
      ${addressFields}
    }
  }
}
`
